import { render, staticRenderFns } from "./NavigationSingle.vue?vue&type=template&id=340fb2cb&scoped=true"
import script from "./NavigationSingle.vue?vue&type=script&lang=js"
export * from "./NavigationSingle.vue?vue&type=script&lang=js"
import style0 from "./NavigationSingle.vue?vue&type=style&index=0&id=340fb2cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340fb2cb",
  null
  
)

export default component.exports